import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
} from '@angular/core'
import {
  ActivatedRoute,
  ActivationEnd,
  NavigationEnd,
  Router,
} from '@angular/router'
import { Subscription } from 'rxjs'

@Component({
  selector: '[propertiesTabs]',
  templateUrl: './properties-tabs.component.html',
  styleUrls: ['./properties-tabs.component.css'],
})
export class PropertiesTabsComponent implements OnInit, OnDestroy {
  visible = false
  router$: Subscription
  private type$: Subscription
  public type: string

  constructor(public router: Router, public route: ActivatedRoute) {}

  ngOnInit() {
    const routeParts = this.router.url.split('/')

    this.visible = routeParts[1] === 'properties' && routeParts.length === 3
    this.type = routeParts[2]

    this.router$ = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const routeParts = this.router.url.split('/')

        this.visible = routeParts[1] === 'properties' && routeParts.length === 3
        this.type = routeParts[2]
      }
    })
  }

  ngOnDestroy(): void {
    this.router$.unsubscribe()
  }
}
